import React, { useState } from 'react'
import { AppButton, AppSecondaryButton } from 'elements'
import {
    RuleCardWrap,
    RuleCardTop,
    RuleQuestion,
    RuleMeta,
    StatusBadge,
    RuleSentence,
    PillTrigger,
    PillAssignee,
    PillPriority,
    PillCustomers,
    RuleActions,
    ToggleWrap,
    Switch,
} from './styles'
import {
    formatAssigneeIcon,
    formatMinutesLabel,
    formatRuleCustomersLabel,
    getPriorityLevel,
    getRuleAssignees,
    getRuleTriggerValues,
} from './utils'

export const RuleCard = ({
    rule,
    onToggle,
    onEdit,
    onDelete,
    onCopy,
    toggling,
    deleting,
}) => {
    const [confirmDelete, setConfirmDelete] = useState(false)
    const priorityLevel = getPriorityLevel(rule.priorityName)
    const icon = formatAssigneeIcon(
        rule.fixedAssignedToTypeName || rule.assignedToTypeName,
    )
    const triggerValues = getRuleTriggerValues(rule)
    const assignees = getRuleAssignees(rule)

    const handleDelete = () => {
        if (!confirmDelete) {
            setConfirmDelete(true)
            return
        }
        onDelete(rule)
        setConfirmDelete(false)
    }

    return (
        <RuleCardWrap $disabled={!rule.isEnabled}>
            <RuleCardTop>
                <div>
                    <RuleQuestion>&ldquo;{rule.questionText}&rdquo;</RuleQuestion>
                    <RuleMeta>
                        Section: {rule.sectionName || '—'}
                        {rule.ticketsLast30Days > 0 &&
                            ` · ${rule.ticketsLast30Days} ticket${
                                rule.ticketsLast30Days === 1 ? '' : 's'
                            } created in last 30 days`}
                        {!rule.isEnabled && ' · paused'}
                    </RuleMeta>
                </div>
                <StatusBadge $active={rule.isEnabled}>
                    {rule.isEnabled ? 'Active' : 'Paused'}
                </StatusBadge>
            </RuleCardTop>
            <RuleSentence>
                When answered{' '}
                {triggerValues.length ? (
                    triggerValues.map((tv, i) => (
                        <React.Fragment key={tv}>
                            {i > 0 && ' or '}
                            <PillTrigger>{tv}</PillTrigger>
                        </React.Fragment>
                    ))
                ) : (
                    <PillTrigger>—</PillTrigger>
                )}
                , create a{' '}
                {rule.ticketType && (
                    <>
                        <b>{rule.ticketType}</b>{' '}
                    </>
                )}
                <PillPriority $level={priorityLevel}>
                    {rule.priorityName || 'Medium'}
                </PillPriority>{' '}
                ticket for{' '}
                {assignees.length > 1 ? (
                    assignees.map((a, i) => (
                        <React.Fragment key={`${a.typeId}-${a.assignedToId}-${i}`}>
                            {i > 0 && '; '}
                            <PillAssignee>
                                {icon} {a.assigneeName || rule.assigneeName || '—'}
                            </PillAssignee>
                        </React.Fragment>
                    ))
                ) : (
                    <PillAssignee>
                        {icon} {rule.assigneeName || '—'}
                    </PillAssignee>
                )}{' '}
                — must acknowledge in{' '}
                <b>{formatMinutesLabel(rule.ackSlaMinutes)}</b>, resolve in{' '}
                <b>{formatMinutesLabel(rule.resolveSlaMinutes)}</b>.
                {rule.escalationPolicyName && (
                    <>
                        {' '}
                        Escalation:{' '}
                        <b>{rule.escalationPolicyName}</b>.
                    </>
                )}
                {rule.categoryName && (
                    <>
                        {' '}
                        Category: <b>{rule.categoryName}</b>.
                    </>
                )}{' '}
                Applies to{' '}
                <PillCustomers $all={rule.appliesToAllCustomers !== false}>
                    {formatRuleCustomersLabel(rule)}
                </PillCustomers>
                .
            </RuleSentence>
            <RuleActions>
                <ToggleWrap>
                    {rule.isEnabled ? 'On' : 'Off'}
                    <Switch>
                        <input
                            type="checkbox"
                            checked={rule.isEnabled}
                            disabled={toggling}
                            onChange={e => onToggle(rule, e.target.checked)}
                        />
                        <span className="slider" />
                    </Switch>
                </ToggleWrap>
                <AppSecondaryButton size="small" onClick={() => onCopy(rule)}>
                    📋 Apply to other questions
                </AppSecondaryButton>
                <AppSecondaryButton size="small" onClick={() => onEdit(rule)}>
                    Edit
                </AppSecondaryButton>
                <AppButton
                    size="small"
                    onClick={handleDelete}
                    disabled={deleting}
                    style={{ color: '#b91c1c' }}
                >
                    {confirmDelete ? 'Confirm delete?' : '🗑 Delete'}
                </AppButton>
            </RuleActions>
        </RuleCardWrap>
    )
}
